import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarRange, Plus } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Header } from "@/components/Header";
import { Button } from "@/components/ui/button";

export default function MyWeeklyPlans() {
  const { t, lang } = useLang();
  const [plans, setPlans] = useState([]);

  useEffect(() => { api.get("/weekly-plans").then(({ data }) => setPlans(data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8 space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="font-heading font-extrabold text-3xl tracking-tight">{lang === "es" ? "Mis Planes Semanales" : "My Weekly Plans"}</h1>
          <Link to="/weekly-planner"><Button className="rounded-full bg-secondary hover:bg-secondary/90" data-testid="new-plan-btn"><Plus className="h-4 w-4" /> {lang === "es" ? "Nuevo plan" : "New plan"}</Button></Link>
        </div>
        {plans.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground">
            <CalendarRange className="h-10 w-10 mx-auto mb-3 opacity-40" />
            <p>{lang === "es" ? "Aún no hay planes semanales." : "No weekly plans yet."}</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {plans.map((p) => (
              <Link key={p.id} to={`/weekly-plans/${p.id}`} data-testid={`plan-card-${p.id}`}
                className="rounded-2xl border border-border bg-card p-5 hover:-translate-y-1 hover:border-primary/40 transition-transform block">
                <span className="h-10 w-10 rounded-xl bg-muted flex items-center justify-center"><CalendarRange className="h-5 w-5 text-primary" /></span>
                <h3 className="font-heading font-bold text-lg mt-3 line-clamp-2">{p.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{p.params?.age_group} · {p.content?.days?.length || 0} {lang === "es" ? "días" : "days"}</p>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
